export const getLocaleString = num => num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const getLocaleTimeFormat = timestamp => {
  const ts = new Date(timestamp)
  return ts.toLocaleString()
}
